import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=5e6dc976&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=5e6dc976&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6dc976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6dc976')) {
      api.createRecord('5e6dc976', component.options)
    } else {
      api.reload('5e6dc976', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=5e6dc976&scoped=true&", function () {
      api.rerender('5e6dc976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/result/Result.vue"
export default component.exports